var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v242.667h242.667V0H0zm81.468 192.754H52.996V93.362h28.471v99.392zM67.513 82.028c-9.55 0-17.319-7.204-17.319-16.058s7.77-16.058 17.319-16.058 17.319 7.204 17.319 16.058-7.77 16.058-17.319 16.058zm124.96 110.726h-29.172v-58.946c.006-.12.432-9.478-4.874-15.068-2.641-2.783-6.279-4.194-10.814-4.194-11.408 0-17.17 8.214-19.612 13.189v65.019H99.529V93.362H128v8.397c9.32-7.561 19.787-11.55 30.335-11.55 27.003 0 34.138 21.093 34.138 32.246v70.299z"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 242.667 242.667"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
